export default function RegistresRoute($stateProvider) {
	// $stateProvider.state('registres-legacy', {
	// 	parent: 'gestion',
	// 	url: '/registres-legacy',
	// 	views: {
	// 		gestion: {
	// 			template: '<ui-view></ui-view>'
	// 		}
	// 	},
	// 	ncyBreadcrumb: {
	// 		label: '{{ "LAYOUT.NAVIGATION.PESEES_FACTURATIONS" | translate }}'
	// 	}
	// });

	// $stateProvider.state('registres-legacy.rndts', {
	// 	url: '/rndts',
	// 	template: '<registres-legacy></registres-legacy>',
	// 	rights: { domain: 'registres', right: 'read' },
	// 	ncyBreadcrumb: {
	// 		parent: 'registres-legacy',
	// 		label: '{{ "REGISTRES.BREADCRUMBS.REGISTRES_RNDTS" | translate}}'
	// 	},
	// 	navigation: {
	// 		menu: 'registres-legacy',
	// 		translate: 'REGISTRES.BREADCRUMBS.REGISTRES_RNDTS',
	// 		order: 1
	// 	},
	// 	search: 'REGISTRES.BREADCRUMBS.REGISTRES_RNDTS'
	// });

	// 	$stateProvider.state('registres-legacy.rep', {
	// 		url: '/rep',
	// 		template: '<rep-legacy></rep-legacy>',
	// 		rights: { domain: 'registres', right: 'read' },
	// 		ncyBreadcrumb: {
	// 			parent: 'registres-legacy',
	// 			label: '{{ "REGISTRES.BREADCRUMBS.REGISTRES_REP" | translate}}'
	// 		},
	// 		navigation: {
	// 			menu: 'registres-legacy',
	// 			translate: 'REGISTRES.BREADCRUMBS.REGISTRES_REP',
	// 			order: 1
	// 		},
	// 		search: 'REGISTRES.BREADCRUMBS.REGISTRES_REP'
	// 	});
}

RegistresRoute.$inject = ['$stateProvider'];
